import { useState, useEffect } from 'react';
import Papa from 'papaparse';

/**
 * Custom React hook to fetch and parse a CSV file containing committee members.
 * The CSV must have the columns: "First Name", "Last Name", "Institution". An optional "Photo" column can be supplied to show an image for each person.
 *
 * @param {string} url Public URL (relative to the application root) of the CSV file.
 * @returns {Array<{name: string, institution: string, photo?: string}>} Parsed member objects. "photo" is optional and will be ignored by components that do not need it.
 */
export default function useCsvMembers(url) {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((csvText) => {
        const { data } = Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
        });
        const formatted = data.map((row) => ({
          name: `${row['First Name']} ${row['Last Name']}`.trim(),
          institution: row['Institution'] || '',
          photo: row['Photo'] || '',
        }));
        setMembers(formatted);
      })
      .catch((err) => {
        console.error(`Failed to load committee CSV from ${url}:`, err);
      });
  }, [url]);

  return members;
}
